import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VideoModal = ({ isOpen, onClose, testimonial }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  const handleShare = () => {
    if (testimonial) {
      const message = `Watch this amazing success story from ${testimonial?.name}! They won ₹${testimonial?.winAmount?.toLocaleString('en-IN')} on Nitin Online Hub. Join this trusted platform today!`;
      window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
    }
  };

  const handleWhatsAppContact = () => {
    const message = `Hi! I just watched ${testimonial?.name}'s success story and I'm interested in starting my gaming journey with Nitin Online Hub. Can you guide me?`;
    window.open(`https://wa.me/917704070169?text=${encodeURIComponent(message)}`, '_blank');
  };

  if (!isOpen || !testimonial) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-card rounded-card shadow-royal max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center">
              <Icon name="Play" size={20} color="white" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-text-primary">
                {testimonial?.name}'s Success Story
              </h3>
              <p className="text-sm text-text-secondary">
                {testimonial?.city}, {testimonial?.state} • Won ₹{testimonial?.winAmount?.toLocaleString('en-IN')}
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-button transition-royal"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Video Content */}
        <div className="p-6">
          {/* Video Player Placeholder */}
          <div className="relative aspect-video bg-muted rounded-card mb-6 flex items-center justify-center">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Play" size={32} color="var(--color-primary)" />
              </div>
              <p className="text-text-secondary">
                Video testimonial would play here
              </p>
              <p className="text-sm text-text-muted mt-2">
                Duration: {testimonial?.duration}
              </p>
            </div>
          </div>

          {/* Testimonial Details */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <h4 className="font-semibold text-text-primary mb-3">Winner Details</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <Icon name="User" size={16} color="var(--color-text-secondary)" />
                  <span className="text-text-secondary">Name:</span>
                  <span className="text-text-primary font-medium">{testimonial?.name}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="MapPin" size={16} color="var(--color-text-secondary)" />
                  <span className="text-text-secondary">Location:</span>
                  <span className="text-text-primary font-medium">{testimonial?.city}, {testimonial?.state}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Gamepad2" size={16} color="var(--color-text-secondary)" />
                  <span className="text-text-secondary">Game:</span>
                  <span className="text-text-primary font-medium">{testimonial?.game}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Calendar" size={16} color="var(--color-text-secondary)" />
                  <span className="text-text-secondary">Date:</span>
                  <span className="text-text-primary font-medium">{testimonial?.date}</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-text-primary mb-3">Winning Amount</h4>
              <div className="bg-gradient-royal rounded-card p-4 text-white text-center">
                <div className="text-3xl font-heading font-bold mb-2">
                  ₹{testimonial?.winAmount?.toLocaleString('en-IN')}
                </div>
                <p className="text-sm opacity-90">Total Winning Amount</p>
              </div>
            </div>
          </div>

          {/* Quote */}
          <div className="bg-surface-secondary rounded-card p-6 mb-6">
            <blockquote className="text-lg text-text-primary italic text-center">
              "{testimonial?.quote}"
            </blockquote>
            <cite className="block text-center text-text-secondary mt-4">
              - {testimonial?.name}, {testimonial?.city}
            </cite>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              variant="default"
              size="lg"
              onClick={handleWhatsAppContact}
              iconName="MessageCircle"
              iconPosition="left"
              className="flex-1 bg-gradient-royal"
            >
              Start Your Winning Journey
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              onClick={handleShare}
              iconName="Share"
              iconPosition="left"
              className="flex-1"
            >
              Share Success Story
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;